import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from './Tooltip';

class TooltipItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showTooltip: false,
        };
    }

    onMouseEnter() {
        this.refs.tooltip.positionRelativeTo(this.refs.element, () => {
            this.setState({ showTooltip: true });
        });
    }

    onMouseOut() {
        this.setState({ showTooltip: false });
    }

    render() {
        const { tooltip, tooltipVariations, ...props } = this.props;
        return (
            <div
                onMouseEnter={this.onMouseEnter.bind(this)}
                onMouseOut={this.onMouseOut.bind(this)}
            >
                <Tooltip
                    visible={this.state.showTooltip}
                    ref="tooltip"
                    maxWidth={200}
                    variations={tooltipVariations}
                >
                    {tooltip}
                </Tooltip>
                <div {...props} ref="element">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

TooltipItem.propTypes = {
    tooltip: PropTypes.string.isRequired,
    tooltipVariations: PropTypes.array,
};

TooltipItem.defaultProps = {
    tooltipVariations: [],
};

export default TooltipItem;



// WEBPACK FOOTER //
// ./js/launch/components/TooltipItem.jsx